import { Controller, useFormContext } from 'react-hook-form';

import useTranslation from '@/utils/hooks/translation/useTranslation';

//type
import type { PlatformFormType } from '@/components/pages/settings/platform/types';

//libs
import { date_format } from '@/lib/settings/optionsConfiguration/platformSettings/platform-settings';

//components
import { SelectComponent } from '@/components/base/Select/SelectComponent/SelectComponent';

export function PlatformDateFormat() {
    const { t } = useTranslation('settings');

    const options = date_format(t);

    const {
        control,
        watch,
        formState: { errors }
    } = useFormContext<PlatformFormType>();

    return (
        <div className="w-full">
            <Controller
                key={'date_format'}
                control={control}
                name={'date_format'}
                render={({ field: { onChange, value } }) => {
                    return (
                        <SelectComponent
                            selected={options?.find((item) => value['value'] === item.value)}
                            setSelected={onChange}
                            label={t('platform_page.date_format')}
                            error={errors.date_format?.message}
                            options={options}
                        />
                    );
                }}
            />
            <p className="mb-3.5 mt-1 font-GMedium text-xs italic text-icoGray-500 dark:text-icoDarkMode-wolf">
                {t('platform_page.date_format_tip_' + watch('date_format')['value'])}
            </p>
        </div>
    );
}
